const DEEP_LINK_KEY = 'ttb.deepLink';

export type DeepLink =
  | { type: 'event'; eventId: string }
  | null;

export function parseDeepLink(): DeepLink {
  const stored = sessionStorage.getItem(DEEP_LINK_KEY);
  if (stored) {
    sessionStorage.removeItem(DEEP_LINK_KEY);
    return parseStartApp(stored);
  }

  const startApp = extractStartAppParam();
  if (!startApp) return null;

  return parseStartApp(startApp);
}

export function storeDeepLink(value: string): void {
  sessionStorage.setItem(DEEP_LINK_KEY, value);
}

function extractStartAppParam(): string | null {
  const params = new URLSearchParams(window.location.search);
  const fromQuery = params.get('tgWebAppStartParam') ?? params.get('startapp');
  if (fromQuery) return fromQuery;

  const hash = window.location.hash?.startsWith('#')
    ? window.location.hash.slice(1)
    : window.location.hash;
  const hashParams = new URLSearchParams(hash ?? '');
  const fromHash = hashParams.get('tgWebAppStartParam') ?? hashParams.get('startapp');
  if (fromHash) return fromHash;

  try {
    const webApp = window.Telegram?.WebApp;
    const startParam = (webApp as Record<string, unknown> | undefined)?.initDataUnsafe as
      | { start_param?: string }
      | undefined;
    if (startParam?.start_param) return startParam.start_param;
  } catch {
    // ignore
  }

  return null;
}

function parseStartApp(value: string): DeepLink {
  const eventMatch = value.match(/^event_(\d+)$/);
  if (eventMatch) {
    return { type: 'event', eventId: eventMatch[1] };
  }
  return null;
}

export function deepLinkToPath(link: DeepLink): string | null {
  if (!link) return null;
  if (link.type === 'event') return `/events/${link.eventId}?members=open`;
  return null;
}
